import type React from "react";
import * as Yup from "yup";
import { ButtonGroupField } from "../../../components/Forms/ButtonGroup";

export const LansenFirmwareUpgradeSubFormSchema = Yup.object().shape({
  target_version: Yup.number().oneOf([134, 135]).required(),
});

export const LansenFirmwareUpgradeInitialValues = {
  target_version: 135, // Default to latest version
};

export interface LansenFirmwareUpgradeSubFormProps {
  namespace: string;
  disabled?: boolean;
}

const LansenFirmwareUpgradeSubForm: React.FC<
  LansenFirmwareUpgradeSubFormProps
> = ({ namespace, disabled = false }) => {
  const withNamespace = (fieldName: string): string => {
    return namespace ? `${namespace}.${fieldName}` : fieldName;
  };

  return (
    <div className="py-4">
      <div>
        <p className="heading-text">Firmware Version</p>
      </div>

      <div className="py-4">
        <ButtonGroupField
          fieldName={withNamespace("target_version")}
          label={{
            label: "Target Version",
            description:
              "Select the firmware version to upgrade the gateway to.",
          }}
          options={[
            { label: "Version 134", value: 134 },
            { label: "Version 135 (Latest)", value: 135 },
          ]}
          disabled={disabled}
          fullWidth={true}
        />
      </div>
    </div>
  );
};

export default LansenFirmwareUpgradeSubForm;
